/* eslint-disable react-hooks/exhaustive-deps */
import debounce from "debounce-promise"
import React from "react"
import {useTranslation} from "react-i18next"
import {partnersService} from "services"
import {KlassDropdownAsync, KlassDropdownAsyncProps} from "../Select"

type Props = Partial<KlassDropdownAsyncProps>

const PartnerSelect: React.FC<Props> = (props) => {
    const {t} = useTranslation(["common"])

    const search = React.useCallback(
        debounce(async (search: string = "") => {
            const {data} = await partnersService.getAllPartners({
                filter: {
                    search
                },
                range: {
                    pageSize: 20,
                    page: 1
                }
            })
            return data
        }, 500),
        []
    )

    return (
        <KlassDropdownAsync
            {...props}
            placeholder={props.placeholder || t("selectField.placeholder")}
            loadOptions={search}
            defaultOptions
            valueKey="id"
            labelKey="name"
        />
    )
}

export default PartnerSelect
